(function autoCloseDetails() {
  document.addEventListener('toggle', function (event) {
    const detailsElement = event.target;
    if (!(detailsElement instanceof HTMLDetailsElement) || !detailsElement.open) return;
    const group = detailsElement.closest('.zyma-pdp-buy-accordions');
    if (!group) return;
    for (const sibling of group.querySelectorAll(':scope > details[open]')) {
      if (sibling !== detailsElement) sibling.removeAttribute('open');
    }
  }, true);

  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();
